__turbopack_context__.v({
  "autocomplete": "li5gjq_autocomplete",
  "autocomplete-carousel": "li5gjq_autocomplete-carousel",
  "autocomplete-carousel-arrow": "li5gjq_autocomplete-carousel-arrow",
  "autocomplete-carousel-arrow-right": "li5gjq_autocomplete-carousel-arrow-right",
  "autocomplete-carousel-header": "li5gjq_autocomplete-carousel-header",
  "autocomplete-carousel-image": "li5gjq_autocomplete-carousel-image",
  "autocomplete-carousel-item": "li5gjq_autocomplete-carousel-item",
  "autocomplete-carousel-link": "li5gjq_autocomplete-carousel-link",
  "autocomplete-carousel-list": "li5gjq_autocomplete-carousel-list",
  "autocomplete-carousel-price": "li5gjq_autocomplete-carousel-price",
  "autocomplete-carousel-price-final": "li5gjq_autocomplete-carousel-price-final",
  "autocomplete-carousel-price-final-discount": "li5gjq_autocomplete-carousel-price-final-discount",
  "autocomplete-carousel-price-regular": "li5gjq_autocomplete-carousel-price-regular",
  "autocomplete-carousel-text": "li5gjq_autocomplete-carousel-text",
  "autocomplete-carousel-title": "li5gjq_autocomplete-carousel-title",
  "autocomplete-carousel-title-results": "li5gjq_autocomplete-carousel-title-results",
  "autocomplete-carousel-title-stars": "li5gjq_autocomplete-carousel-title-stars",
  "autocomplete-carousel-track": "li5gjq_autocomplete-carousel-track",
  "autocomplete-categories": "li5gjq_autocomplete-categories",
  "autocomplete-cms": "li5gjq_autocomplete-cms",
  "autocomplete-cms-content": "li5gjq_autocomplete-cms-content",
  "autocomplete-full-width": "li5gjq_autocomplete-full-width",
  "autocomplete-heading": "li5gjq_autocomplete-heading",
  "autocomplete-list": "li5gjq_autocomplete-list",
  "autocomplete-product-tiny": "li5gjq_autocomplete-product-tiny",
  "autocomplete-product-tiny-name": "li5gjq_autocomplete-product-tiny-name",
  "autocomplete-slide": "li5gjq_autocomplete-slide",
  "autocomplete-slide-image": "li5gjq_autocomplete-slide-image",
  "autocomplete-slide-text": "li5gjq_autocomplete-slide-text",
  "autocomplete-slider": "li5gjq_autocomplete-slider",
  "autocomplete-term": "li5gjq_autocomplete-term",
  "autocomplete-terms": "li5gjq_autocomplete-terms",
  "autocomplete-terms-list": "li5gjq_autocomplete-terms-list",
  "autocomplete-total": "li5gjq_autocomplete-total",
  "autocompleteCard": "li5gjq_autocompleteCard",
  "autocompleteMobile": "li5gjq_autocompleteMobile",
  "autocompleteSheet": "li5gjq_autocompleteSheet",
  "cardSeeMore": "li5gjq_cardSeeMore",
  "product-price": "li5gjq_product-price",
  "product-tiny-image": "li5gjq_product-tiny-image",
  "search-category": "li5gjq_search-category",
  "search-container": "li5gjq_search-container",
  "search-container-mobile": "li5gjq_search-container-mobile",
  "see-all-occurrences-btn": "li5gjq_see-all-occurrences-btn",
  "sheetSeeMore": "li5gjq_sheetSeeMore",
});
